!(function () {
    "use strict";
    var t,
        e = {
            5592: function () {},
            6227: function (t, e, i) {
                var s = i(7367);
                const n = "onVariantChange";
                class r extends CustomEvent {}
                class a {
                    constructor(t) {
                        let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        (this.container = t),
                            (this.updateHistory = e),
                            (this.variantSelector = t.querySelector('[name="id"]')),
                            (this.elementData = t.querySelector("[data-variant-selector-data]")),
                            this.loadData(JSON.parse(this.elementData.innerHTML)),
                            this.variantSelector?.addEventListener("change", this.onInputChanged);
                    }
                    loadData(t) {
                        (this.elementData.innerHTML = JSON.stringify(t)), (this.data = t);
                    }
                    getVariantId() {
                        return parseInt(this.variantSelector?.value);
                    }
                    getVariant() {
                        const t = this.getVariantId();
                        return this.data.variants.find((e) => e.id === t);
                    }
                    setVariantId(t) {
                        if (isNaN(t) || !isFinite(t)) return;
                        if (!this.data.variants.some((e) => e.id === t)) return;
                        if (!this.variantSelector) return;
                        const e = this.getVariant();
                        (this.variantSelector.value = t.toString()),
                        window.location.href.includes("products") &&
                        this.updateHistory &&
                        (t === (0, s.variantFirstAvailableOrDefault)({ variants: this.data.variants }).id ? (0, s.queryReplaceParam)("variant", null) : (0, s.queryReplaceParam)("variant", t.toString())),
                            this.onVariantSelected();
                        const i = this.getVariant(),
                            a = new r(n, { bubbles: !0, cancelable: !1, detail: { oldVariant: e, newVariant: i, variantSelector: this } });
                        this.variantSelector.dispatchEvent(a);
                    }
                    getOptionValues() {
                        const t = {};
                        return (
                            this.data.options.forEach((e) => (t[e] = [])),
                                this.data.variants.forEach((e) => {
                                    e.options.forEach((e, i) => {
                                        const s = this.data.options[i];
                                        -1 === t[s].indexOf(e) && t[s].push(e);
                                    });
                                }),
                                t
                        );
                    }
                    setVariantOption(t, e) {
                        this.getOptionValues();
                        const i = this.getVariant(),
                            s = [];
                        for (let n = 0; n < this.data.options.length; n++) {
                            let r;
                            (r = n === t ? e : i.options[n]), s.push(r);
                        }
                        const n = this.data.variants.find((t) => t.options.every((t, e) => e >= this.data.options.length || s[e] === t));
                        return n ? (this.setVariantId(n.id), n) : null;
                    }
                    onInputChanged = (t) => {
                        this.setVariantId(parseInt(this.variantSelector.value));
                    };
                    onVariantSelected() {}
                    dispose() {
                        this.variantSelector.removeEventListener("change", this.onInputChanged);
                    }
                }
                const o = "[data-swatch]",
                    l = "[data-swatch-object]",
                    c = "[data-swatch-dropdown]",
                    d = "data-swatch-position",
                    u = "data-value",
                    h = "is-selected";
                class p extends a {
                    constructor(t, e) {
                        super(t, e),
                            (this.swatches = Array.from(t.querySelectorAll(o).values())),
                            this.container.querySelectorAll(l).forEach((t) => {
                                t.addEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(c).forEach((t) => {
                                t.addEventListener("change", this.onDropdownChange);
                            }),
                            this.onVariantSelected();
                    }
                    onSwatchClick = (t) => {
                        const e = this.container.querySelectorAll("[data-swatch-title]"),
                            i = t.currentTarget,
                            s = i.closest(o);
                        let n = i.querySelector("[data-image]"),
                            r = this.container.closest(".o-product-thumbnail")?.querySelector(".o-product-thumbnail__image-container");
                        if (!s) return;
                        const a = parseInt(s.getAttribute(d) || ""),
                            l = i.getAttribute(u),
                            v = i.getAttribute("data-variant-id"),
                            c = i.getAttribute("data-title");
                        c &&
                        e?.forEach((t) => {
                            t.innerText = c;
                        }),
                        !isNaN(a) && l && (n && r && (r.innerHTML = n.innerHTML), this.setVariantOption(a - 1, l));

                        document.querySelectorAll('.product-grid-badge .product-grid-badge__inner').forEach(el => {
                            el.style.display = 'none';
                        });

                        // Select the specific element with the matching data-variant-id
                        let variantBadge = document.querySelector(`.product-grid-badge__inner[data-variant-id="${v}"]`);
                        if (variantBadge) {
                            variantBadge.style.display = '';
                        }
                    };
                    onDropdownChange = (t) => {
                        const e = t.currentTarget,
                            i = e.closest(o);
                        if (!i) return;
                        const s = parseInt(i.getAttribute(d) || "");
                        isNaN(s) || this.setVariantOption(s - 1, e.value);
                    };
                    onVariantSelected() {
                        const t = this.getVariant();
                        if (
                            t &&
                            (this.swatches.forEach((e) => {
                                const i = parseInt(e.getAttribute(d) || "");
                                if (isNaN(i)) return;
                                const s = t.options[i - 1];
                                e.querySelectorAll(l).forEach((t) => {
                                    if (t.getAttribute(u) === s) {
                                        t.classList.add(h);
                                        let e = t.parentElement;
                                        e && e.classList.add(h);
                                    } else {
                                        t.classList.remove(h);
                                        let e = t.parentElement;
                                        e && e.classList.remove(h);
                                    }
                                });
                                e.querySelectorAll(c).forEach((t) => (t.value = s)),
                                    e.querySelectorAll("[data-swatch-value]").forEach((t) => {
                                        t.textContent = s;
                                    });
                            }),
                                this.container.classList.contains("o-product-thumbnail__footer"))
                        ) {
                            const e = new CustomEvent("updatePricing", { bubbles: !0, cancelable: !1, detail: { variant: t } });
                            this.container.dispatchEvent(e);
                        }
                    }
                    dispose() {
                        super.dispose(),
                            this.container.querySelectorAll(l).forEach((t) => {
                                t.removeEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(c).forEach((t) => {
                                t.removeEventListener("change", this.onDropdownChange);
                            });
                    }
                }
                const m = "is-disabled",
                    y = "is-active",
                    v = "is-open",
                    g = "is-hidden",
                    b = "is-disabled",
                    f = document.createElement("template");
                f.innerHTML = "\n  <slot></slot>\n";
                class S extends CustomEvent {}
                class E extends HTMLElement {
                    get value() {
                        return this.input ? this.input.valueAsNumber : this.fallbackValue;
                    }
                    set value(t) {
                        null !== this.max && (t = Math.min(this.max, t)), null !== this.min && (t = Math.max(this.min, t)), this.input && (this.input.valueAsNumber = t), (this.fallbackValue = t);
                    }
                    get min() {
                        const t = this.input ? this.input.min : this.fallbackMin;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set min(t) {
                        null === t ? (this.input && (this.input.min = ""), (this.fallbackMin = null)) : (this.input && (this.input.min = t.toString()), (this.fallbackMin = this.fallbackMin));
                    }
                    get max() {
                        const t = this.input ? this.input.max : this.fallbackMax;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set max(t) {
                        null === t ? (this.input && (this.input.max = ""), (this.fallbackMax = null)) : (this.input && (this.input.max = t.toString()), (this.fallbackMax = this.fallbackMin));
                    }
                    get disabled() {
                        return this.hasAttribute("disabled");
                    }
                    set disabled(t) {
                        t ? this.setAttribute("disabled", "disabled") : this.removeAttribute("disabled"), this.updateDisabled();
                    }
                    input = null;
                    btnMinus = null;
                    btnPlus = null;
                    line = null;
                    fallbackValue = 0;
                    fallbackMin = null;
                    fallbackMax = null;
                    constructor() {
                        super();
                        this.attachShadow({ mode: "open" }).appendChild(f.content.cloneNode(!0)),
                            (this.btnMinus = this.querySelector(".is-minus")),
                            (this.btnPlus = this.querySelector(".is-plus")),
                            (this.input = this.querySelector('input[type="number"]')),
                            this.classList.add("o-quantity-selector"),
                            (this.line = this.getAttribute("line")),
                            this.btnMinus?.addEventListener("click", this.onMinusClick),
                            this.btnPlus?.addEventListener("click", this.onPlusClick),
                            this.input?.addEventListener("change", this.onInputChanged),
                            this.updateDisabled();
                    }
                    onPlusClick = (t) => {
                        t.preventDefault(), (this.value += 1), this.onQuantityChanged();
                    };
                    onMinusClick = (t) => {
                        t.preventDefault(), (this.value -= 1), this.onQuantityChanged();
                    };
                    onInputChanged = (t) => {
                        (this.value = this.input?.valueAsNumber || this.value), this.onQuantityChanged();
                    };
                    onQuantityChanged() {
                        if (this.line)
                            try {
                                (0, s.cartChange)({ quantity: this.value, id: this.line });
                            } catch (t) {
                                console.warn(t);
                            }
                        const t = new S("onQtyChange", { bubbles: !0, cancelable: !1, detail: { qtySelector: this, newValue: this.value } });
                        this.dispatchEvent(t);
                    }
                    updateDisabled() {
                        [this.btnMinus, this.btnPlus, this.input].forEach((t) => {
                            var e;
                            this.disabled
                                ? (e = t) && ((e.disabled = !0), e.classList.add("is-disabled"))
                                : ((t) => {
                                    t && ((t.disabled = !1), t.classList.remove("is-disabled"));
                                })(t);
                        }),
                            this.disabled ? this.classList.add("is-disabled") : this.classList.remove("is-disabled");
                    }
                }
                customElements.get("quantity-selector") || customElements.define("quantity-selector", E);
                const L = "[data-label-element]",
                    A = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn"),
                    q = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn [data-label-element]");
                class C {
                    btnAdd = null;
                    btnAddMobile = null;
                    btnAddDesktop = null;
                    qtySelector = null;
                    form = null;
                    swatches = null;
                    rechargeSubscriptionOptionsElement = null;
                    rechargeWidget = null;
                    stickyPrice = null;
                    money = null;
                    compare = null;
                    parentCarousel = null;
                    parentCarouselTiles = null;
                    adding = !1;
                    ogPrice = 0;
                    customRetailPercentage = 0;
                    customRetailWording = null;
                    constructor(t) {
                        (this.container = t), this.queryChildren(t), this.attachEvents();
                    }
                    queryChildren(t) {
                        (this.btnAdd = t.querySelector("[data-product-form-add]")),
                            (this.btnAddDesktop = this.btnAdd ? this.btnAdd.querySelector(".is-desktop") : null),
                            (this.btnAddMobile = this.btnAdd ? this.btnAdd.querySelector(".is-mobile") : null),
                            (this.qtySelector = t.querySelector("[data-product-form-qty]")),
                            (this.money = t.querySelectorAll("[data-product-money]")),
                            (this.compare = t.querySelectorAll("[data-product-compare-money]")),
                            (this.rechargeSubscriptionOptionsElement = t.querySelector("[data-product-recharge-selling-plans]")),
                            (this.stickyPrice = document.querySelector("[data-sticky-form]")),
                            (this.parentCarousel = document.querySelector("[data-product-gallery-carousel]")),
                            (this.parentCarouselTiles = document.querySelectorAll(".c-product-gallery__media-container")),
                            setTimeout(() => {
                                this.rechargeWidget = document.querySelector(".rc-widget");
                            }, 2e3);
                    }
                    onVariantChange() {
                        if (!this.swatches) return;
                        const t = this.swatches.getVariant(),
                            e = t?.id,
                            i = Array.from(this.parentCarouselTiles).find((t) => t.getAttribute("data-variant") === e.toString());
                        if ((i?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" }), void 0 === t)) return;
                        const { inventory_management: n, inventory_policy: r, inventory_quantity: a, price: o, compare_at_price: l, selling_plan_allocations: c } = t,
                            d = (0, s.cartGetQuantityOfVariant)(t.id);
                        this.qtySelector && (this.qtySelector.max = "shopify" === n && "deny" === r ? (a || 0) - d : null),
                        this.container.classList.contains("c-product-main__form") && (this.updatePriceElements(o, l), this.updateAddToCart(t), this.updateRechargeVariant(c, o, l));
                    }
                    updateRechargeVariant(t, e, i) {
                        const n = this.container.querySelector(".recharge-subscription-widget"),
                            r = n?.querySelector(".subscription-radio"),
                            a = (n?.querySelector(".onetime-radio"), this.container.querySelector('[name="selling_plan"]')),
                            o = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            l = this.container.querySelector(".c-product-form__price"),
                            c = this.container.querySelector(".rc-selling-plans-dropdown__select");
                        0 === t.length
                            ? (this.container?.classList.remove("has-selling-plan"),
                                setTimeout(() => {
                                    a && (a.value = ""), l && (l.innerHTML = `${(0, s.printMoney)(e)}`), o && (o.innerHTML = `${(0, s.printMoney)(e)}`);
                                }, 1e3))
                            : (r.click(), a && (a.value = `${c?.value}`), this.container?.classList.add("has-selling-plan"), this.updateStickyPriceBasedOnSubscription());
                    }
                    updatePriceElements(t, e) {
                        this.money && this.money.forEach((e) => (e.innerText = (0, s.printMoney)(t))),
                        this.compare && (e ? this.compare.forEach((t) => (t.innerText = (0, s.printMoney)(e))) : this.compare.forEach((t) => (t.innerText = "")));
                        const i = document.querySelector(".subscription-radio"),
                            n = document.querySelector(".onetime-radio"),
                            r = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            a = this.container?.querySelector(".c-product-form__price");
                        i && i.classList.contains("rc-radio--active")
                            ? setTimeout(() => {
                                const e = i.querySelector(".rc-radio__label .rc-radio__price"),
                                    o = n.querySelector(".rc-radio__label");
                                let l = Number(t);
                                (l *= 0.9),
                                o && (o.innerText = `One-time purchase ${(0, s.printMoney)(Number(t))}`),
                                e && (e.innerText = `${(0, s.printMoney)(Number(l))}`),
                                r && this.updatePriceValue(r, (0, s.printMoney)(Number(l))),
                                a && this.updatePriceValue(a, (0, s.printMoney)(Number(l)));
                            }, 200)
                            : (r && this.updatePriceValue(r, (0, s.printMoney)(t)), a && this.updatePriceValue(a, (0, s.printMoney)(t)));
                    }
                    updateStickyPriceBasedOnSubscription() {
                        if (!this.rechargeWidget) return;
                        this.rechargeWidget.querySelectorAll('input[type="radio"]').forEach((t) => {
                            t.addEventListener("change", () => {
                                this.updateStickyPriceElement(t);
                            }),
                            t.checked && this.updateStickyPriceElement(t);
                        });
                    }
                    updateStickyPriceElement(t) {
                        const e = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            i = this.container?.querySelector(".c-product-form__price");
                        if ("subscription" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.remove("is-one-time");
                            const n = t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price");
                            let r = n?.innerText;
                            t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price .is-price") && (r = `${(0, s.printMoney)(Number(this.ogPrice))}`), this.updatePriceValue(e, r), this.updatePriceValue(i, r);
                        } else if ("onetime" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.add("is-one-time");
                            const t = document.querySelector("[data-product-money]"),
                                s = t?.innerText;
                            this.updatePriceValue(e, s), this.updatePriceValue(i, s);
                        }
                    }
                    updatePriceValue(t, e) {
                        setTimeout(() => {
                            t && (t.innerText = e || "");
                        }, 200);
                    }
                    updateAddToCart(t) {
                        if (!this.btnAdd) return;
                        const e = (0, s.cartGetQuantityOfVariant)(t.id),
                            { available: i, inventory_policy: n, inventory_management: r, inventory_quantity: a } = t;
                        i ? ("continue" != n && null != r && (a || 0) - e <= 0 ? this.btnAllInCart() : this.btnAvailable()) : this.btnSoldOut();
                    }
                    btnAvailable() {
                        if (this.btnAdd) {
                            if (document.body.classList.contains("c-page--product"))
                                this.btnAdd.querySelectorAll(L).forEach((t) => (t.innerHTML = (0, s.t)("products.product.add_to_cart_pdp"))), q && (q.innerHTML = (0, s.t)("products.product.add_to_cart_pdp"));
                            else {
                                if (!this.btnAddDesktop || !this.btnAddMobile) return;
                                this.btnAddDesktop.querySelectorAll(L).forEach((t) => (t.innerHTML = (0, s.t)("products.product.quick_add"))),
                                q && (q.innerHTML = (0, s.t)("products.product.quick_add")),
                                    this.btnAddMobile.querySelectorAll(L).forEach((t) => (t.innerHTML = (0, s.t)("products.product.add_to_cart")));
                            }
                            this.btnAdd.classList.remove(b),
                                this.btnAdd.removeAttribute(m),
                                this.btnAdd.removeAttribute("disabled"),
                                (this.btnAdd.disabled = !1),
                            A && (A.classList.remove(b), A.removeAttribute(m), A.removeAttribute("disabled"), (A.disabled = !1));
                        }
                    }
                    btnAllInCart() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(b),
                            this.btnAdd.setAttribute(m, m),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(L).forEach((t) => (t.innerHTML = (0, s.t)("products.product.all_in_cart"))),
                        q && (q.innerHTML = (0, s.t)("products.product.all_in_cart")),
                        A && (A.classList.add(b), A.setAttribute(m, m), A.setAttribute("disabled", "")));
                    }
                    btnSoldOut() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(b),
                            this.btnAdd.setAttribute(m, m),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(L).forEach((t) => {
                                t.innerHTML = (0, s.t)("products.product.sold_out");
                            }),
                        q && (q.innerHTML = (0, s.t)("products.product.sold_out")),
                        A && (A.classList.add(b), A.setAttribute(m, m), A.setAttribute("disabled", "")));
                    }
                    btnAdded() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(L).forEach((t) => (t.innerHTML = (0, s.t)("products.product.added_to_cart"))),
                        q && (q.innerHTML = (0, s.t)("products.product.added_to_cart")),
                            this.btnAdd.classList.remove(b),
                            this.btnAdd.removeAttribute(m),
                            this.btnAdd.removeAttribute("disabled"),
                            (this.btnAdd.disabled = !1),
                        A && (A.classList.remove(b), A.removeAttribute(m), A.removeAttribute("disabled"), (A.disabled = !1)));
                    }
                    btnPending() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(L).forEach((t) => (t.innerHTML = (0, s.t)("products.product.cart_pending"))),
                        q && (q.innerHTML = (0, s.t)("products.product.cart_pending")),
                            (this.btnAdd.disabled = !0),
                        A && (A.disabled = !0));
                    }
                    initSwatches() {
                        this.swatches = new p(this.container, !0);
                    }
                    attachEvents() {
                        this.initSwatches(),
                            this.container.addEventListener(n, () => this.onVariantChange()),
                            setTimeout(() => {
                                this.updateStickyPriceBasedOnSubscription(), this.updateRechargeCustomPercentage();
                            }, 2e3),
                        A &&
                        A.addEventListener("click", (t) => {
                            t.preventDefault(), t.stopPropagation();
                            let e = document.querySelector("[data-product-main] [data-product-form-add]");
                            e && e.click();
                        });
                    }
                    updateRechargeCustomPercentage() {
                        const t = document.querySelector("[data-product-main]"),
                            e = t?.querySelectorAll(".rc-radio__subscription"),
                            i = document?.querySelectorAll(".rc-radio__price");
                        (this.customRetailPercentage = Number(t?.getAttribute("data-custom-percentage"))),
                            (this.customRetailWording = String(t?.getAttribute("data-custom-wording"))),
                            e?.forEach((t) => {
                                this.customRetailPercentage && this.customRetailPercentage > 0 && (t.innerHTML = `${(0, s.t)("products.product.custom_subscribe_save")} ${this.customRetailPercentage}% ${this.customRetailWording}`);
                            }),
                        this.customRetailPercentage &&
                        this.customRetailPercentage > 0 &&
                        i?.forEach((t) => {
                            this.ogPrice = Number(String(t.textContent).replace("$", "").replace(".", ""));
                            const e = 1 - this.customRetailPercentage / 100;
                            let i = this.ogPrice / e / 100;
                            i = Math.round(100 * i) / 100;
                            const n = 100 * Math.ceil(i);
                            t.innerHTML = `\n          <span class="is-price">${(0, s.printMoney)(Number(this.ogPrice))}</span>\n          <span class="is-compare">${(0, s.printMoney)(Number(n))}</span>\n        `;
                        });
                    }
                    reinitialiseSwatches(t) {
                        this.detatchEvents(), this.swatches?.loadData(t), this.attachEvents(), this.onVariantChange();
                    }
                    detatchEvents() {
                        this.swatches?.dispose();
                    }
                }
                const T = (t, e) => {
                        let i;
                        return function () {
                            for (var s = arguments.length, n = new Array(s), r = 0; r < s; r++) n[r] = arguments[r];
                            i && clearTimeout(i),
                                (i = setTimeout(() => {
                                    t.apply(this, n), (i = null);
                                }, e));
                        };
                    },
                    k = (t, e, i, s) => {
                        let n,
                            r,
                            a = !1,
                            o = !1;
                        e.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                a && t.preventDefault();
                            });
                        }),
                            t.addEventListener("mousedown", (e) => {
                                (o = !0), t.classList.add(y), (n = e.pageX - t.offsetLeft), (r = t.scrollLeft);
                            }),
                            t.addEventListener("mouseleave", () => {
                                (o = !1), (a = !1), t.classList.remove(y);
                            }),
                            t.addEventListener("mouseup", () => {
                                (o = !1), t.classList.remove(y), setTimeout(() => (a = !1), 500);
                            }),
                            t.addEventListener("mousemove", (e) => {
                                if (!o) return;
                                a = !0;
                                const i = 3 * (e.pageX - t.offsetLeft - n);
                                (t.scrollLeft = r - i), t.setAttribute("data-scroll-left", (r - i).toString());
                            }),
                            t.addEventListener(
                                "scroll",
                                T(() => {
                                    let n = x(t, e);
                                    s && s(x(t, e)), i && (n + 1 >= e.length && !P(t) ? (i.style.width = (1 / e.length) * 100 + "%") : P(t) ? (i.style.width = "100%") : (i.style.width = ((n + 1) / e.length) * 100 + "%"));
                                }, 50)
                            );
                    },
                    _ = (t, e, i, s, n) => {
                        n && (n.style.width = (1 / e.length) * 100 + "%"),
                            s.addEventListener("click", () => {
                                let i = x(t, e);
                                if (i + 1 >= e.length || P(t)) (t.scrollLeft = 0), n && (n.style.width = (1 / e.length) * 100 + "%");
                                else {
                                    let s = 0;
                                    for (let t = 0; t <= i; t++) s += e[i].clientWidth;
                                    (t.scrollLeft = s), n && (n.style.width = ((i + 2) / e.length) * 100 + "%");
                                }
                            }),
                            i.addEventListener("click", () => {
                                let i = x(t, e);
                                if (i <= 0) (t.scrollLeft = t.scrollWidth), n && (n.style.width = "100%");
                                else {
                                    let s = 0;
                                    for (let t = 0; t < i - 1; t++) s += e[i].clientWidth;
                                    (t.scrollLeft = s), n && (n.style.width = (i / e.length) * 100 + "%");
                                }
                            });
                    },
                    x = (t, e) => {
                        let i = t.scrollLeft - 5;
                        for (let t = 0; t < e.length; t++) if (e[t].offsetLeft >= i) return t;
                        return e.length - 1;
                    },
                    P = (t) => {
                        let e = t.scrollWidth - t.clientWidth;
                        return t.scrollLeft > e - 50;
                    };
                const w = { xxsmall: "375px", xsmall: "480px", small: "750px", medium: "1100px", large: "1350px", xlarge: "1650px", xxlarge: "2000px" },
                    M = Object.entries(w).reduce((t, e) => {
                        const [i, s] = e;
                        return (t[i] = parseInt(s)), t;
                    }, {}),
                    V = (t) => window.innerWidth >= M[t] || 0,
                    I = "data-section-initialized";
                class N {
                    static registrations = {};
                    static register(t, e) {
                        const i = [];
                        return (
                            document.querySelectorAll(t).forEach((s) => {
                                if (N.isRegistered(s)) return;
                                const n = new e(s, t);
                                i.push(n), n.queryChildren(s), n.init(), n.attachEvents(s);
                            }),
                                (this.registrations[t] = e),
                                i
                        );
                    }
                    static recheck(t) {
                        const e = this.registrations[t];
                        return e ? N.register(t, e) : [];
                    }
                    static isRegistered(t) {
                        return t.hasAttribute(I);
                    }
                    constructor(t, e) {
                        if (((this.container = t), (this.selector = e), this.container.setAttribute(I, "true"), (this.shopifyContainer = this.container.parentElement), this.shopifyContainer && this.shopifyContainer.id))
                            try {
                                this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
                            } catch (t) {
                                console.warn(t);
                            }
                        this.innerHtmlObserver = null;
                    }
                    replaceContainer(t) {
                        this.container.removeAttribute(I),
                            this.detatchEvents(this.container),
                            (this.container.innerHTML = t.innerHTML),
                            this.container.setAttribute(I, "true"),
                            this.queryChildren(this.container),
                            this.init(),
                            this.attachEvents(this.container);
                    }
                    init() {}
                    onInnerHtmlMutationObserved = (t, e) => {
                        if (!t.length) return;
                        if (!this.shopifyContainer) return;
                        const [i] = t,
                            s = [];
                        i.removedNodes.forEach((t) => s.push(t));
                        -1 !== s.findIndex((t) => t === this.shopifyContainer) && (console.log("Section", this.id, "reloaded."), this.dispose(), N.recheck(this.selector));
                    };
                    dispose() {
                        this.container.removeAttribute(I), this.detatchEvents(this.container), this.innerHtmlObserver && this.innerHtmlObserver.disconnect();
                    }
                }
                const H = "[data-accordion-title]";
                class O {
                    animationSpeed = 400;
                    constructor(t) {
                        (this.el = t), (this.summary = t.querySelector(H)), (this.content = t.querySelector("[data-accordion-body]")), (this.animation = null), (this.isClosing = !1), (this.isExpanding = !1);
                    }
                    onClick(t) {
                        t && t.preventDefault(), (this.el.style.overflow = "hidden"), this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink();
                    }
                    shrink() {
                        if (!this.summary) return;
                        this.isClosing = !0;
                        const t = `${this.el.offsetHeight}px`,
                            e = `${this.summary.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate({ height: [t, e] }, { duration: this.animationSpeed, easing: "ease-out" })),
                            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
                            (this.animation.oncancel = () => (this.isClosing = !1));
                    }
                    open() {
                        (this.el.style.height = `${this.el.offsetHeight}px`), (this.el.open = !0), window.requestAnimationFrame(() => this.expand());
                    }
                    expand() {
                        if (!this.summary || !this.content) return;
                        this.isExpanding = !0;
                        const t = `${this.el.offsetHeight}px`,
                            e = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate({ height: [t, e] }, { duration: this.animationSpeed, easing: "ease-out" })),
                            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
                            (this.animation.oncancel = () => (this.isExpanding = !1));
                    }
                    onAnimationFinish(t) {
                        (this.el.open = t), (this.animation = null), (this.isClosing = !1), (this.isExpanding = !1), (this.el.style.height = this.el.style.overflow = "");
                    }
                }
                class B {
                    accordionSlideElements = null;
                    accordionSlides = [];
                    disableSize = null;
                    constructor(t, e) {
                        (this.container = t), (this.accordionSlideElements = Array.from(t.querySelectorAll("[data-accordion-slide]"))), e && (this.disableSize = e), this.attachEvents();
                    }
                    openAccordion() {
                        this.accordionSlideElements && (this.container.classList.contains(v) || (this.container.classList.add(v), this.accordionSlideElements.forEach((t) => t.setAttribute("open", "open"))));
                    }
                    closeAccordion() {
                        this.accordionSlideElements && this.container.classList.contains(v) && (this.container.classList.remove(v), this.accordionSlideElements.forEach((t) => t.removeAttribute("open")));
                    }
                    closeActiveSlides(t, e) {
                        this.accordionSlides &&
                        0 != this.accordionSlides.length &&
                        this.accordionSlides.forEach((i) => {
                            i.el != e && i.el.open && i.onClick(t);
                        });
                    }
                    onSlideClick(t, e) {
                        if (!this.accordionSlides || 0 == this.accordionSlides.length) return;
                        if (this.disableSize && V(this.disableSize)) return void t.preventDefault();
                        const i = this.accordionSlides[e];
                        i && (this.closeActiveSlides(t, i.el), i.onClick(t));
                    }
                    onResize() {
                        this.disableSize &&
                        V(this.disableSize) &&
                        this.accordionSlides.forEach((t) => {
                            t.el.open || t.onClick();
                        });
                    }
                    attachEvents() {
                        this.accordionSlideElements &&
                        this.accordionSlideElements.length > 0 &&
                        (this.accordionSlideElements.forEach((t, e) => {
                            const i = new O(t);
                            this.accordionSlides.push(i);
                            const s = t.querySelector(H);
                            s && s.addEventListener("click", (t) => this.onSlideClick(t, e));
                        }),
                        this.disableSize && (window.addEventListener("resize", () => this.onResize()), this.onResize()));
                    }
                    detachEvents() {
                        this.accordionSlideElements &&
                        this.accordionSlideElements.length > 0 &&
                        this.accordionSlideElements.forEach((t, e) => {
                            const i = t.querySelector(H);
                            i && i.removeEventListener("click", (t) => this.onSlideClick(t, e));
                        });
                    }
                }
                const R = "[data-card-carousel-tile-video]",
                    D = "[data-card-carousel-sound-icon-default]",
                    $ = "[data-card-carousel-sound-icon-mute]",
                    W = 2e3;
                class z extends HTMLElement {
                    carousel = null;
                    carouselTiles = null;
                    carouselPrev = null;
                    carouselNext = null;
                    carouselButtons = [this.carouselNext, this.carouselPrev];
                    productCarousel = null;
                    autoPlayInterval = null;
                    autoplayTime = (() => W)();
                    progressSegments = null;
                    soundButtons = null;
                    constructor(t) {
                        super();
                    }
                    connectedCallback() {
                        (this.carousel = this.querySelector("[data-card-carousel]")),
                            (this.carouselTiles = this.querySelectorAll("[data-card-carousel-tile]")),
                            (this.carouselPrev = this.querySelector("[data-card-carousel-prev]")),
                            (this.carouselNext = this.querySelector("[data-card-carousel-next]")),
                            (this.carouselButtons = [this.carouselNext, this.carouselPrev]),
                            (this.progressSegments = this.querySelectorAll("[data-card-carousel-progress-segment]")),
                            (this.soundButtons = this.querySelectorAll("[data-card-carousel-sound-button]")),
                            (this.debouncedScroll = T(() => this.scrollEvents, 200)),
                            (this.productCarousel = document.querySelector("[data-product-main-stories]")),
                            this.initCarousel(),
                        null !== this.soundButtons &&
                        this.soundButtons.forEach((t) => {
                            t.addEventListener("click", () => this.toggleVideoSound(t));
                        });
                    }
                    initCarousel() {
                        null !== this.carousel &&
                        null !== this.carouselTiles &&
                        (k(this.carousel, this.carouselTiles, void 0, this.toggleVideoPlayback.bind(this)),
                        null !== this.carouselPrev && null !== this.carouselNext && _(this.carousel, this.carouselTiles, this.carouselPrev, this.carouselNext));
                    }
                    startCarousel() {
                        this.progressSegments && this.carousel?.addEventListener("scroll", () => this.debouncedScroll()),
                            this.scrollEvents(),
                            this.carouselPrev?.addEventListener("click", () => this.navigationEvents("prev")),
                            this.carouselNext?.addEventListener("click", () => this.navigationEvents("next"));
                    }
                    stopCarousel() {
                        this.autoPlayInterval && (clearInterval(this.autoPlayInterval), (this.autoPlayInterval = null)), this.carousel?.removeEventListener("scroll", () => this.debouncedScroll());
                    }
                    scrollEvents() {
                        this.rebindTimer(),
                            setTimeout(() => {
                                this.updateSlideProgress(!0, 0);
                            }, 100);
                    }
                    navigationEvents(t) {
                        let e = x(this.carousel, this.carouselTiles);
                        if (
                            (this.rebindTimer(),
                            "next" == t && ((e += 1), e == this.carouselTiles?.length && (e = 0)),
                            "prev" == t && ((e -= 1), e < 0 && (e = this.carouselTiles.length - 1)),
                                this.updateSlideProgress(!0, e),
                            this.carouselTiles?.length === e + 1)
                        ) {
                            const t = new CustomEvent("slide_end", { detail: null, bubbles: !0 });
                            this.dispatchEvent(t);
                        }
                    }
                    updateSlideProgress() {
                        let t = arguments.length > 1 ? arguments[1] : void 0;
                        !1 !== (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0])
                            ? (this.progressSegments.forEach((t) => {
                                t.classList.remove(y);
                            }),
                                this.progressSegments[t].classList.add(y))
                            : this.progressSegments.forEach((t) => {
                                t.classList.add("is-paused"), t.classList.remove(y);
                            });
                    }
                    rebindTimer() {
                        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                        this.autoPlayInterval && clearInterval(this.autoPlayInterval);
                        const e = this.carouselTiles ? this.carouselTiles[t] : null;
                        if (!this.productCarousel)
                            if (e) {
                                const i = e.querySelector(R);
                                i
                                    ? i.readyState >= 1
                                        ? ((this.autoplayTime = Math.floor(1e3 * i.duration)), this.startAutoPlayInterval(t))
                                        : (i.onloadedmetadata = () => {
                                            (this.autoplayTime = Math.floor(1e3 * i.duration)), this.startAutoPlayInterval(t);
                                        })
                                    : ((this.autoplayTime = W), this.startAutoPlayInterval(t));
                            } else (this.autoplayTime = W), this.startAutoPlayInterval(t);
                    }
                    startAutoPlayInterval(t) {
                        this.autoplayTime &&
                        this.carouselNext &&
                        (this.autoPlayInterval = setInterval(() => {
                            this.carouselNext.click();
                            let e = t + 1;
                            e >= this.carouselTiles.length && (e = 0), this.rebindTimer(e);
                        }, this.autoplayTime));
                    }
                    toggleVideoPlayback(t) {
                        if (!this.carouselTiles) return (this.autoplayTime = W), void this.rebindTimer();
                        let e = t;
                        void 0 === t && (e = x(this.carousel, this.carouselTiles));
                        const i = this.carouselTiles[e]?.querySelector(R);
                        if ((i && ((this.autoplayTime = Math.floor(1e3 * i.duration)), this.rebindTimer(), i.play()), e > 0)) {
                            const t = this.carouselTiles[e - 1],
                                i = t?.querySelector(R),
                                s = t?.querySelector(D),
                                n = t?.querySelector($);
                            i && (i.pause(), (i.muted = !0), (i.currentTime = 0), s && n && (s.classList.add("hidden"), n.classList.remove("hidden")));
                        }
                    }
                    toggleVideoSound(t) {
                        const e = x(this.carousel, this.carouselTiles);
                        if (this.carouselTiles) {
                            const i = this.carouselTiles[e]?.querySelector(R);
                            if (i) {
                                i.muted = !i.muted;
                                const e = t.querySelector(D),
                                    s = t.querySelector($);
                                e && s && (e.classList.toggle("hidden", i.muted), s.classList.toggle("hidden", !i.muted));
                            }
                        }
                    }
                }
                customElements.get("card-carousel") || customElements.define("card-carousel", z);
                const j = "[data-proof-carousel]",
                    F = "[data-carousel-next]",
                    Q = "[data-carousel-prev]";
                N.register(
                    "[data-product-main]",
                    class extends N {
                        formElement = null;
                        form = null;
                        accordionElement = null;
                        accordion = null;
                        readMoreButton = null;
                        readLessButton = null;
                        soundBtn = null;
                        productVideo = null;
                        unmuteBtn = null;
                        muteBtn = null;
                        parentCarousel = null;
                        parentCarouselTiles = null;
                        parentCarouselProgress = null;
                        currentCardCarouselIndex = 0;
                        queryChildren(t) {
                            (this.formElement = t.querySelector("[data-product-form]")),
                                (this.accordionElement = t.querySelector("[data-product-accordion]")),
                                (this.readMoreButton = t.querySelector("[data-read-more-button]")),
                                (this.readLessButton = t.querySelector("[data-read-less-button]")),
                                (this.soundBtn = t.querySelector("[data-tile-sound-button]")),
                                (this.productVideo = t.querySelector("[data-product-video]")),
                                (this.unmuteBtn = t.querySelector("[data-tile-sound-icon-default]")),
                                (this.muteBtn = t.querySelector("[data-tile-sound-icon-mute]")),
                                (this.parentCarousel = t.querySelector("[data-parent-carousel]")),
                                (this.parentCarouselTiles = t.querySelectorAll("[data-parent-carousel-tile]")),
                                (this.parentCarouselProgress = t.querySelector("[data-carousel-progress]")),
                            this.parentCarouselTiles && ((this.currentCardCarouselIndex = 0), (this.cardCarousels = t.querySelectorAll("card-carousel")), this.cardCarousels && this.container.addEventListener("slide_end", () => {}));
                        }
                        attachEvents(t) {
                            const e = t.querySelector("[data-product-gallery-carousel]"),
                                i = t.querySelector(j),
                                s = t.querySelectorAll("[data-pin]");
                            s.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    const i = e.currentTarget;
                                    if (i instanceof Element) {
                                        if (i.classList.contains("is-active")) return;
                                        {
                                            const e = t.getAttribute("data-pin");
                                            e && this.scrollToSlide(e),
                                                s.forEach((t) => {
                                                    t.classList.remove("is-active");
                                                }),
                                                t.classList.add("is-active");
                                        }
                                    }
                                });
                            }),
                            i && this.initCarousel(i),
                            e && this.initCarousel(e),
                            null !== this.parentCarousel && null !== this.parentCarouselTiles && k(this.parentCarousel, this.parentCarouselTiles),
                                this.playCardCarousel(!1);
                            const r = t.querySelector("[data-proof-container]");
                            if (r) {
                                const t = r.querySelector(Q),
                                    e = r.querySelector(F);
                                t?.addEventListener("click", () => {
                                    const t = document.querySelector(".c-proof-points__pin.is-active");
                                    if (t) {
                                        t.classList.remove("is-active");
                                        let e = t.previousElementSibling;
                                        for (; e && "PICTURE" === e.tagName; ) e = e.previousElementSibling;
                                        if (!e) {
                                            const t = Array.from(s);
                                            e = t[t.length - 1];
                                        }
                                        e && e.classList.add("is-active");
                                    }
                                }),
                                    e?.addEventListener("click", () => {
                                        const t = document.querySelector(".c-proof-points__pin.is-active");
                                        if (t) {
                                            t.classList.remove("is-active");
                                            let e = t.nextElementSibling;
                                            for (; e && "PICTURE" === e.tagName; ) e = e.nextElementSibling;
                                            e || (e = s[0]), e && e.classList.add("is-active");
                                        }
                                    });
                            }
                            this.formElement && ((this.form = new C(this.formElement)), this.formElement.addEventListener(n, this.onVariantChange)), this.accordionElement && (this.accordion = new B(this.accordionElement));
                            const a = document.querySelector("[data-read-more-full-content]");
                            this.readMoreButton?.addEventListener("click", (t) => {
                                t.preventDefault(), a?.classList.remove(g), this.readMoreButton?.classList.add(g), this.readLessButton?.classList.remove(g);
                            }),
                                this.readLessButton?.addEventListener("click", (t) => {
                                    t.preventDefault(), a?.classList.add(g), this.readLessButton?.classList.add(g), this.readMoreButton?.classList.remove(g);
                                }),
                                this.productVideo?.addEventListener("click", () => {
                                    const t = this.productVideo.getElementsByTagName("video");
                                    t[0].paused ? t[0].play() : t[0].pause();
                                }),
                                this.soundBtn?.addEventListener("click", (t) => {
                                    if ((t.stopImmediatePropagation(), this.soundBtn)) {
                                        this.unmuteBtn?.classList.toggle(g), this.muteBtn?.classList.toggle(g);
                                        const t = this.productVideo.getElementsByTagName("video");
                                        t[0].muted = !t[0].muted;
                                    }
                                }),
                                document.addEventListener("DOMContentLoaded", () => {
                                    setTimeout(() => {
                                        this.setRechargeSelection();
                                    }, 500),
                                        setTimeout(() => {
                                            this.setRechargeSelection();
                                        }, 1e3),
                                        setTimeout(() => {
                                            this.setRechargeSelection();
                                        }, 1500),
                                        setTimeout(() => {
                                            this.setRechargeSelection();
                                        }, 2e3);
                                });
                        }
                        playCardCarousel(t) {
                            !0 === t && (this.currentCardCarouselIndex = this.currentCardCarouselIndex + 1), this.cardCarousels[this.currentCardCarouselIndex] && this.cardCarousels[this.currentCardCarouselIndex].startCarousel();
                        }
                        scrollToSlide(t) {
                            const e = document.querySelector(j),
                                i = e.querySelector(`[data-media-id="${t}"]`);
                            if (i) {
                                const t = i.offsetLeft;
                                e && (e.scrollLeft = t);
                                const s = { left: t, behavior: "smooth" };
                                e?.scrollTo(s);
                            }
                        }
                        initCarousel(t) {
                            if (!t) return;
                            const e = t.parentElement,
                                i = t.querySelectorAll("[data-media-id]"),
                                s = e?.querySelector(Q),
                                n = e?.querySelector(F),
                                r = e?.querySelector("[data-gallery-carousel-progress]");
                            i && (k(t, i, r), s && n && _(t, i, s, n, r));
                        }
                        detatchEvents() {
                            this.accordion && this.accordion.detachEvents(), this.form && this.form.detatchEvents(), this.formElement && this.formElement.removeEventListener(n, this.onVariantChange);
                        }
                        onVariantChange = (t) => {
                            const { detail: e } = t,
                                { oldVariant: i, newVariant: s } = e;
                        };
                        setRechargeSelection() {
                            var t = new URLSearchParams(window.location.search).get("purchase"),
                                e = this.container.querySelector('input.rc-radio__input[value="onetime"]'),
                                i = this.container.querySelector('input.rc-radio__input[value="subscription"]');
                            "onetime" === t ? e?.click() : i?.click();
                        }
                    }
                );
            },
        },
        i = {};
    function s(t) {
        var n = i[t];
        if (void 0 !== n) return n.exports;
        var r = (i[t] = { exports: {} });
        return e[t].call(r.exports, r, r.exports, s), r.exports;
    }
    (s.m = e),
        (t = []),
        (s.O = function (e, i, n, r) {
            if (!i) {
                var a = 1 / 0;
                for (d = 0; d < t.length; d++) {
                    (i = t[d][0]), (n = t[d][1]), (r = t[d][2]);
                    for (var o = !0, l = 0; l < i.length; l++)
                        (!1 & r || a >= r) &&
                        Object.keys(s.O).every(function (t) {
                            return s.O[t](i[l]);
                        })
                            ? i.splice(l--, 1)
                            : ((o = !1), r < a && (a = r));
                    if (o) {
                        t.splice(d--, 1);
                        var c = n();
                        void 0 !== c && (e = c);
                    }
                }
                return e;
            }
            r = r || 0;
            for (var d = t.length; d > 0 && t[d - 1][2] > r; d--) t[d] = t[d - 1];
            t[d] = [i, n, r];
        }),
        (s.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        })()),
        (s.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (s.j = 794),
        (function () {
            var t = { 794: 0 };
            s.O.j = function (e) {
                return 0 === t[e];
            };
            var e = function (e, i) {
                    var n,
                        r,
                        a = i[0],
                        o = i[1],
                        l = i[2],
                        c = 0;
                    if (
                        a.some(function (e) {
                            return 0 !== t[e];
                        })
                    ) {
                        for (n in o) s.o(o, n) && (s.m[n] = o[n]);
                        if (l) var d = l(s);
                    }
                    for (e && e(i); c < a.length; c++) (r = a[c]), s.o(t, r) && t[r] && t[r][0](), (t[r] = 0);
                    return s.O(d);
                },
                i = (self.webpackChunkreflect_boilerplate = self.webpackChunkreflect_boilerplate || []);
            i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
        })(),
        s.O(void 0, [4121], function () {
            return s(6227);
        });
    var n = s.O(void 0, [4121], function () {
        return s(5592);
    });
    n = s.O(n);
})();
